import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { sleep } from "../utils/functions";

const ResumeContext = React.createContext();

const defaultHeadings = {
  SUM: "Summary",
  AD: "Academic Details",
  WE: "Professional Experience",
  SK: "Skills",
  CR: "Courses",
  INT: "Internships",
  LAN: "Languages",
  REF: "References",
  ACT: "Extra-curricular Activities",
  HOB: "Hobbies",
  CL: "Contact",
  PRO: 'Projects'
};

function ResumeContextProvider({ children }) {
  const [resumeInfo, setResumeInfo] = useState({});
  const [resumeHeadings, setResumeHeadings] = useState(defaultHeadings);
  const [colorOptions, setColorOptions] = useState([]);
  const [activeColor, setActiveColor] = useState([]);
  const [activeFontSize, setActiveFontSize] = useState("12px");
  const [activeDesign, setActiveDesign] = useState("rockstar");
  const [documentRef, setDocumentRef] = useState();
  const [documentDataRef, setDocumentDataRef] = useState();
  const [imgSupported, setImgSupported] = useState(true);
  const [infoUpdating, toggleUpdating] = useState(false);

  const updateResumeInfo = useRef(
    debounce(
      (section, newDetails, resumeInfoRef) =>
        updateInfo(section, newDetails, resumeInfoRef),
      1000
    )
  );

  const updateInfo = async (section, newDetails, resumeInfoRef) => {
    toggleUpdating(true);
    const resumeInfoTemp = { ...resumeInfoRef };
    resumeInfoTemp[section] = { ...newDetails };
    setResumeInfo(resumeInfoTemp);
    await sleep(1000);
    toggleUpdating(false);
  };

  return (
    <ResumeContext.Provider
      value={{
        resumeInfo,
        setResumeInfo,
        updateResumeInfo,
        colorOptions,
        setColorOptions,
        activeColor,
        setActiveColor,
        activeFontSize,
        setActiveFontSize,
        activeDesign,
        setActiveDesign,
        resumeHeadings,
        setResumeHeadings,
        documentRef,
        setDocumentRef,
        documentDataRef,
        setDocumentDataRef,
        imgSupported,
        setImgSupported,
        infoUpdating,
      }}
    >
      {children}
    </ResumeContext.Provider>
  );
}

export { ResumeContext, ResumeContextProvider };
